import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

import clientSDK from '../../../App/ClientSDK'
import {
  axiosErrorHandler,
  IThunkReject,
} from '../../../App/Util/axiosErrorHandler'
import { DATE_STORE_KEY_FORMAT } from '../../../Common/settings/dateFormats'
import { TErrorDescriptor } from '../../../ErrorHandling/store'
import { IDateRange, IGetBlocksReturn } from '../../types'
import { IAPIBlock } from '../../types/api'
import { apiBlocksTransformer } from '../transformer/apiBlocksTransformer'

export const fetchBlocks = createAsyncThunk<
  IGetBlocksReturn,
  { dateRange: IDateRange },
  IThunkReject<TErrorDescriptor>
>('blocks/fetch', async (formObject, { rejectWithValue }) => {
  const { dateRange } = formObject
  let apiData: null | IGetBlocksReturn = null

  try {
    const fetchRange = `${dateRange.start.format(
      DATE_STORE_KEY_FORMAT,
    )}/${dateRange.end.format(DATE_STORE_KEY_FORMAT)}`

    const promise = clientSDK
      .instance()
      .get<{ total: number; list: IAPIBlock[] }>(
        `calendar/blockeds/${fetchRange}`,
      )

    const result = await promise

    apiData = {
      list: apiBlocksTransformer(result.data.list),
      dateRange,
    }
  } catch (error) {
    const handleAxiosError = axiosErrorHandler<TErrorDescriptor>(res => res)
    const generatedError = handleAxiosError(error as Error | AxiosError)
    return rejectWithValue(generatedError)
  }

  return apiData
})
